<template>
    <div class="module module--space-default">
        <div class="trainer-preview">
            <div class="container container--nooverflow">
                <div class="trainer-preview__inner">
                    <div class="trainer-preview__top">
                        <h3 class="trainer-preview__title h5">{{title}}</h3>
                        <router-link :to="{ name: 'Trainers'}">
                            <div class="trainer-preview__all more-link">
                                <span v-translate>more</span>
                                <Icon name="arrow-right"></Icon>
                            </div>
                        </router-link>
                    </div>
                    <swiper :options="sliderOptions" class="trainer-preview__slider">
                        <swiper-slide v-for="trainer in tenTrainers" :key="trainer.id" class="trainer-preview__slide">
                            <router-link :to="{name: 'Trainer', params: {id: trainer.id}}">
                                <TrainerIcon :trainer="trainer"></TrainerIcon>
                            </router-link>
                        </swiper-slide>
                        <swiper-slide>
                            <router-link  :to="{ name: 'Trainers'}">
                                <TrainerIcon :trainer="false"></TrainerIcon>
                            </router-link>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TrainerIcon from '@/components/TrainerIcon';

export default {
    components: {
        TrainerIcon
    },
    props: {
        title: {
            type: String
        },
        trainers: {
            type: Array,
        }
    },
    data () {
        return {
             sliderOptions: {
                speed: 400,
                slidesPerView: 2,
                spaceBetween: 10,
                breakpoints: {
                    450: {
                        slidesPerView: 3,
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    760: {
                        slidesPerView: 4,
                        slidesPerGroup: 3,
                        spaceBetween: 32,
                    },
                    980: {
                        slidesPerView: 5,
                        slidesPerGroup: 4,
                        spaceBetween: 32,
                    },
                    1180: {
                        slidesPerView: 7,
                        slidesPerGroup: 6,
                        spaceBetween: 32,
                    }
                }
            },
        }
    },
    computed: {
        tenTrainers() {
            return this.trainers.slice(0, 10)
        }
    }
}
</script>

<style lang="scss" scoped>
.trainer-preview {
    overflow: hidden;

    &__top {
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include mq($until: tablet) {
            margin-bottom: 20px;
        }
    }

    &__slider {
        overflow: visible;
    }

}
</style>